import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../../model/Application";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";

class ApplicationReallocateFacultyModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;

    public application: Application;
    public faculties: any[];
    public owningFacultyCode: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.faculties = this.resolve.faculties;
        this.owningFacultyCode = this.application.owningFacultyCode;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        this.applicationService.reallocateStudentCreditApplicationFaculty(this.application, this.owningFacultyCode)
            .then((updatedAssessment) => {
                this.$log.debug("updatedAssessment", updatedAssessment);
                this.toaster.pop({type: "success", title: "Owning faculty successfully re-allocated and notification sent"});
                this.close({$value: updatedAssessment});
                this.$state.go("dashboard");
            })
            .catch((reason) => {
                this.$log.debug("Failed to invite", reason);
                this.toaster.pop({type: "failure", title: "Failed to re-allocate faculty"});
            })
            .finally(() => {
                this.loadingService.hide();
            });
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const ApplicationReallocateFacultyModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ApplicationReallocateFacultyModalController,
    template: require("./application-reallocate-faculty-modal.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/reallocate-faculty-modal/application-reallocate-faculty-modal.component.ts